
import { Component} from '@angular/core';

@Component({
  selector: 'fa-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'ForeignAdmits';
  constructor(
  ) {}

}
